import React, { useRef } from "react";
import CheckBox from "../CheckBox";
import { useTranslation } from "react-i18next";
import { useOnClickOutside } from "../../../services/hooks";
import IconButton from "../IconButton";

const StatusFilter = ({ selectedStatus = [], setSelectedStatus, closeModal }) => {
    const { t } = useTranslation();
    const targetRef = useRef(null);
    useOnClickOutside(targetRef, closeModal);

    const toggleSort = (value) => {
        if (selectedStatus.includes(value)) {
            setSelectedStatus(selectedStatus.filter(v => v !== value));
            return;
        }

        setSelectedStatus([...selectedStatus, value]);
    }

    return (
        <div ref={targetRef} className="statusFilterContent">
            <div className="closeButton">
                <IconButton isIcon iconName="crossClose" onClick={closeModal} />
            </div>
            <div className="statusItem" onClick={() => toggleSort('backup')}>
                <CheckBox value={selectedStatus.includes('backup')} />
                {t('dashboard.couriersbar.BACKUP_GROUP_LABEL')}
            </div>

            <div className="statusItem" onClick={() => toggleSort('awaiting')}>
                <CheckBox value={selectedStatus.includes('awaiting')} />
                {t('dialogs.couriers.AWAITING_APPROVAL_LABEL')}
            </div>

            <div className="statusItem" onClick={() => toggleSort('waiting')}>
                <CheckBox value={selectedStatus.includes('waiting')} />
                {t('dialogs.couriers.WAITING_FOR_ORDERS')}
            </div>

            <div className="statusItem" onClick={() => toggleSort('ready')}>
                <CheckBox value={selectedStatus.includes('ready')} />
                {t('dialogs.couriers.READY_LABEL')}
            </div>

            <div className="statusItem" onClick={() => toggleSort('onroute')}>
                <CheckBox value={selectedStatus.includes('onroute')} />
                {t('dialogs.couriers.ON_ROUTE_LABEL')}
            </div>
        </div>
    )
}

export default StatusFilter;